import { Permission } from '../../components/Authorize/permissions';
import { ANALYTICS_READ } from '../../components/Authorize/permissions/resources';

export const ANALYTICS_GA_READ = new Permission('AnalyticsGA:read', ANALYTICS_READ.description);
export const ANALYTICS_VISION_READ = new Permission('AnalyticsVision:read', ANALYTICS_READ.description);
